import { FormControl, Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import LoadingComponent from '../../../../components/Loading';
import * as CONST from '../../../../constants/FieldsConst';
import { validFielddHelper } from '../../../../helpers/ValidFieldsHelper';
import { useNotification } from '../../../../helpers/notification';
import BotonNuevoComponent from '../../../entidades/components/BotonNuevo';
import { saveTiposEventosAction } from '../TiposEventosAction';

const FormTiposEventos = ({}) => {
  const dispatch = Redux.useDispatch();
  const { addNotification } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const tiposEventosStore = Redux.useSelector((state) => state.tiposEventos);

  const activo = tiposEventosStore.activo;

  const dataDefault = {
    [CONST.NAME]: '',
    [CONST.MAX]: 0,
  };

  const [tipoEvento, setTipoEvento] = React.useState(dataDefault);
  const [dataError, setDataRequired] = React.useState({
    [CONST.NAME]: false,
    [CONST.MAX]: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (activo === null) {
      setTipoEvento(dataDefault);
      return;
    }
    let data = {};
    Object.keys(tipoEvento).map(
      (key) => (data[key] = tiposEventosStore.activo[key])
    );
    setTimeout(() => {
      setTipoEvento(data);
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setTipoEvento({ ...tipoEvento, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = tipoEvento[key];
      const valid = val === null || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    const valid = await _validDataForm();

    if (valid) {
      setLoadingSave(true);
      await saveTiposEventosAction(
        { dispatch, addNotification },
        entidadesStore.activo.id,
        activo ? activo.id : null,
        {
          ...tipoEvento,
          [CONST.ENTITY_ID]: entidadesStore.activo.id,
        }
      );
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form" sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={6} md={12}>
          <LoadingComponent
            isLoading={loadingSave}
            text={activo ? 'Actualizando...' : 'Guardando...'}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.NAME}
            required
            label="Nombre"
            value={tipoEvento.name}
            onChange={(e) => _handleSetDataField(CONST.NAME, e.target.value)}
            helperText={dataError.name ? validFielddHelper(1) : null}
            error={dataError.name}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl fullWidth>
            <TextField
              size="small"
              type="number"
              label="Máximo de invitados"
              value={tipoEvento.max}
              onChange={(e) => _handleSetDataField(CONST.MAX, e.target.value)}
              id={CONST.MAX}
              InputProps={{
                inputProps: { min: 0 },
              }}
              helperText={dataError.max ? validFielddHelper(1) : null}
              error={dataError.max}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} align="center" sx={{ m: 2 }}>
          <BotonNuevoComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            morado
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormTiposEventos;
